import React from 'react';

import { ValueWithDisabled } from 'editor/src/component/DesktopSidebar/TabContents/ProductTabContent/ProductControlContent/ECommerceProductContent/eCommerceVariantUtils';
import ColorDot from 'editor/src/component/DesktopSidebar/TabContents/ProductTabContent/ProductControlContent/ProductControls/elements/ColorElement/ColorDot';

import ECommerceProductControlOption from './ECommerceProductControlOption';

import styles from './index.module.scss';

interface Props {
  title: string;
  selectedValue: string;
  options: ValueWithDisabled[];
  onChange: (value: string) => void;
}

function ECommerceProductControl({ title, selectedValue, options, onChange }: Props) {
  // Unlike the catalogue Color control, there is no colour-shaped-key fallback here — option
  // values are arbitrary merchant strings. So a mixed control (some values with a hex, some
  // without) has no reason to become a colour control: require EVERY value to carry a hex,
  // otherwise a half-swatch row would look broken.
  const allValuesHaveHex = options.every((option) => !!option.colorHex);

  return (
    <div className="cy-ecommerce-product-control">
      <div className={styles.controlTitle}>{title}</div>
      <div className={allValuesHaveHex ? styles.swatches : undefined}>
        {options.map((option) =>
          allValuesHaveHex ? (
            <button
              key={option.name}
              type="button"
              role="checkbox"
              aria-checked={selectedValue === option.name}
              aria-label={option.title ?? option.name}
              title={option.title ?? option.name}
              className={styles.swatchButton}
              disabled={option.disabled}
              onClick={() => onChange(option.name)}
            >
              <ColorDot
                colorHex={option.colorHex}
                texture={option.texture}
                selected={selectedValue === option.name}
                disabled={option.disabled}
                className={styles.swatchDot}
              />
            </button>
          ) : (
            <ECommerceProductControlOption
              key={option.name}
              option={option}
              selected={selectedValue === option.name}
              onChange={onChange}
            />
          ),
        )}
      </div>
    </div>
  );
}

export default React.memo(ECommerceProductControl);
